import styled from 'styled-components';

const Wrap = styled.span`
  display: inline-block;
  vertical-align: middle;
  position: relative;
  width: 84px;
  height: 18px;
  &.lv-3 {
    background: url(${require('./images/3.gif')}) no-repeat 0 0 / contain;
  }
  &.lv-3_5 {
    background: url(${require('./images/3_5.gif')}) no-repeat 0 0 / contain;
  }
  &.lv-4 {
    background: url(${require('./images/4.gif')}) no-repeat 0 0 / contain;
  }
  &.lv-4_5 {
    background: url(${require('./images/4_5.gif')}) no-repeat 0 0 / contain;
  }
  &.lv-5 {
    background: url(${require('./images/5.gif')}) no-repeat 0 0 / contain;
  }
`;

/**
 * 主播星级
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
const StarGrade = (props) => {
  const { level = '' } = props;
  const lv = level.toString().replace('.', '_');

  if (!level) {
    return null;
  }

  return <Wrap className={`lv-${lv}`}></Wrap>;
};

export default StarGrade;
